const labs = {
  title: "",
  subtitle: "",
  demoButton: ""
};

export default labs;
